import React from "react";
import styled from "styled-components";
import { Text } from "@coaching-culture/ui";

import catSrc from "../../img/cat.jpg";

const Container = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 48px;
  flex: 1;
`;

const Cat = styled.img`
  border-radius: 12px;
  border: 1px solid ${(props) => props.theme.colors.border};
  max-width: 100%;
  width: 500px;
`;

const NotFound = () => {
  return (
    <Container>
      <Text as="h1" fontSize="display" mb={1} fontWeight={600} color="black">
        Not found
      </Text>
      <Text mb={4} color="textMuted">
        You've found a place that doesn't exist. Here's a picture of a cat.
      </Text>
      <Cat src={catSrc} alt="A cat" />
    </Container>
  );
};

export default NotFound;
